module.exports = __webpack_public_path__ + "static/media/mb1.bb469a4a.png";